module.exports = __webpack_public_path__ + "img/1.045cdfd9.jpg";